import styled from 'styled-components'

import { device } from 'utils/style'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 24px auto;
  width: calc(100% - 48px);
`

const Content = styled.div<{ isLargeContent?: boolean; isSmallContent?: boolean }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  width: 100%;

  @media ${device.laptop} {
    margin: 0px auto;
    max-width: ${({ isLargeContent, isSmallContent }): string => {
      if (isLargeContent) {
        return '1300px'
      }
      if (isSmallContent) {
        return '800px'
      }
      return '1024px'
    }};
  }
`

const Card = styled.div<{ small?: boolean }>`
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 8px 8px 16px rgba(102, 119, 150, 0.1);
  display: flex;
  flex-direction: column;
  gap: ${({ small }): string => (small ? '16px' : '24px')};
  justify-content: stretch;
  padding: ${({ small }): string => (small ? '24px' : '48px')};
  width: calc(100% - ${({ small }): string => (small ? '48px' : '96px')});
`

const CardHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

const Divider = styled.div`
  background-color: #e3e3e3;
  height: 1px;
  width: 100%;
`

const Actions = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
`

const GridItem = styled.div`
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const DeleteItemAction = styled.div<TSFixMe>`
  align-items: center;
  cursor: pointer;
  display: inline-flex;

  svg {
    height: 20px;
    width: 20px;
  }
`

export default {
  Container,
  Content,
  Card,
  CardHeader,
  Divider,
  Actions,
  GridItem,
  DeleteItemAction
}
